/**
=========================================================
* Material Dashboard 2 PRO React TS - v1.0.2
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-2-pro-react-ts
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import React, { FC, forwardRef, useMemo } from "react";

// @mui material components
import { AvatarProps } from "@mui/material";

// Custom styles for MDAvatar
import MDAvatarRoot from "./MDAvatarRoot";

// declare props types for MDAvatar
interface Props extends AvatarProps {
  bgColor?:
    | "transparent"
    | "primary"
    | "secondary"
    | "info"
    | "success"
    | "warning"
    | "error"
    | "light"
    | "dark";
  size?: "xs" | "sm" | "md" | "lg" | "xl" | "xxl";
  shadow?: "none" | "xs" | "sm" | "md" | "lg" | "xl" | "xxl" | "inset";
  [key: string]: any;
}

const InitialAvatar: FC<Props> = forwardRef(({ name, size, shadow, ...rest }, ref) => {
    const firstLetter = name.substring(0, 1).toUpperCase();
    const colors = [
        '#1ca970', '#7215da', '#5557ca', '#71a131', '#08c1de', '#c1be5a',
        '#8626c2', '#c4d063', '#581f53', '#8a5ac2', '#508d36', '#a64a8e',
        '#ee2197', '#e21478', '#7f3b83', '#7b0a19', '#6e1c22', '#6894ad',
        '#344327', '#cc6bd8', '#a4113b', '#a0da50', '#b27907', '#0dc863',
        '#4b26b5', '#386b9f', '#404975', '#143825', '#ee7593', '#6bae54'
    ];
    const alphabets = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    const random = alphabets.indexOf(firstLetter);
    // const random = Math.floor(Math.random() * colors.length);
    const color = colors[random];
    const bgColor = "primary";
    const backgroundColor = useMemo<any>(() => color, [color]);

    return (
        <MDAvatarRoot ref={ref} ownerState={{ shadow, bgColor, size }} style={{background: backgroundColor}} {...rest}>
            {firstLetter}
        </MDAvatarRoot>
    )
});

// Declaring default props for InitialAvatar
InitialAvatar.defaultProps = {
  size: "md",
  shadow: "none",
  name: ""
};

const InitialAvatarMemo = React.memo(function InitialAvatarMemo(props: Props){
    return (
        <InitialAvatar {...props} />
    )
}, (prevProps, nextProps) => {
    if(prevProps.name !== nextProps.name){
        return false;
    }
    return true;
});

export default InitialAvatarMemo;
